import React from 'react';
import '../../assets/styles/MessageBubble.css';
import PropTypes from 'prop-types';
import {formatDateTimeShort} from "../../utlis/generalUtils";

const MessageBubble = ({ type, text, timestamp }) => {
    const isUser = type === 'user';

    return (
        <div className={`message-container ${isUser ? 'user-message' : 'ai-message'}`}>
            {!isUser && (
                <div className="message-avatar ai-avatar">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M12 8V4H8"/>
                        <rect width="16" height="12" x="4" y="8" rx="2"/>
                        <path d="m14 8-2 2-2-2"/>
                        <path d="M4 14h16"/>
                    </svg>
                </div>
            )}

            <div className={`message-bubble ${isUser ? 'user-bubble' : 'ai-bubble'}`}>
                <p className="message-text">{text}</p>
                <div className={`message-time ${isUser ? 'user-time' : 'ai-time'}`}>
                    {formatDateTimeShort(timestamp)}
                </div>
            </div>

            {isUser && (
                <div className="message-avatar user-avatar">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                        <circle cx="12" cy="7" r="4"/>
                    </svg>
                </div>
            )}
        </div>
    );
};

MessageBubble.propTypes = {
    type: PropTypes.oneOf(['user', 'agent']).isRequired,
    text: PropTypes.string.isRequired,
    timestamp: PropTypes.string,
};

export default MessageBubble;